import { jsx } from '@emotion/react/jsx-runtime';
import { buttonContents } from './shared.js';
import { buttonStyles } from './styles.js';

const Button = ({
  priority,
  size,
  icon: iconSvg,
  iconSide,
  hideLabel,
  nudgeIcon,
  type = "button",
  isLoading = false,
  loadingAnnouncement = "Loading",
  cssOverrides,
  children,
  theme,
  ...props
}) => /* @__PURE__ */ jsx(
  "button",
  {
    css: buttonStyles({
      size,
      priority,
      icon: iconSvg,
      hideLabel,
      iconSide,
      nudgeIcon,
      cssOverrides,
      isLoading,
      theme
    }),
    type,
    "aria-live": "polite",
    "aria-label": isLoading ? loadingAnnouncement : void 0,
    ...props,
    children: buttonContents({
      hideLabel,
      iconSvg,
      isLoading,
      children
    })
  }
);

export { Button };
